import { Component, OnInit, OnChanges, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../service/apiServices';
import Swal from 'sweetalert2';
import * as $ from "jquery";
import { Global } from '../../global';
import { Location } from '@angular/common';

import { jsPDF } from "jspdf";
import domtoimage from 'dom-to-image';
import { AuthService } from '../../service/auth/auth.service'

@Component({
  selector: 'app-historico-regulacao',
  templateUrl: './regulation-historic.component.html',
  styleUrls: ['./regulation-historic.component.css']
})
export class RegulationHistoricComponent implements OnInit {

  @Input() regulacaoId: any = 0;
  @Input() tipoRegulacaoHistorico: any = 0;

  historico: any = {};
  listaUsuarios: any = [];
  dadosImpressoHistorico: any = {};
  alterandoAgenda: boolean = false;
  solicitacaoExame: any = {};

  cidadao: any = {};
  filtroAgendamento: any = {};
  consulta: any = {};
  agendaHoraTroca: any = {};
  nomeImpressoHistorico: any = 'REGULACAO_HISTORICO_EXAME.frx';

  @Output() limparVisualizarHistorico = new EventEmitter();

  global_: any

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private router: Router,
    private global: Global,
    private location: Location,
    private authService: AuthService
  ) {
    this.global_ = this.global
  }

  ngOnInit() {
    
  }

  ngOnChanges() {
    
    Swal.fire('Favor aguarde')
    Swal.showLoading()
    if (this.tipoRegulacaoHistorico) {
      this.getProfissional().then(
        result => {
          this.listaUsuarios = result;
          if (this.tipoRegulacaoHistorico == 1) {
            this.obterRegulacaoConsulta(this.regulacaoId)
          }
          if (this.tipoRegulacaoHistorico == 2) {
            this.obterRegulacaoExame(this.regulacaoId)
          }
        },
        error => {
          this.showError(error)
        }
      )
    }
    else Swal.close()
  }

  fecharModal = () => {
    this.historico = {};
    this.limparVisualizarHistorico.emit();
    this.alterandoAgenda = false;
    $("#modalHistoricoRegulacao").toggleClass("show");
    $("#modalHistoricoRegulacao").css("display", "none");
    Swal.close();
  }

  obterRegulacaoExame = (id) => {
    this.service.Get(`RegulacaoExame/${id}`).then(
      result => {
        this.historico = result;
        this.consulta = result;
        this.cidadao = this.consulta.Cidadao;
        this.agendaHoraTroca = this.consulta.AgendaHora;

        if (this.consulta.AgendaHora) {
          this.getAgendaDia(this.historico.AgendaHora.agenda_dia_id).then(
            result => {
              var data = result['agenda_em'];
              
              this.historico.AgendaHora.agendamento = data.split('T')[0] + 'T' + this.historico.AgendaHora.hora;
            },
            error => {
              this.showError(error)
            }
          )
        }

        if (this.historico.CidSubCategoria) {
          this.historico.cid_subcategoria_texto = this.historico.CidSubCategoria.codigo + ' - ' + this.historico.CidSubCategoria.nome
        }
        if (this.historico.profissional_id_realizacao) {
          this.service.Get(`Profissional/${this.historico.profissional_id_realizacao}`).then(
            result => {
              this.historico.ProfissionalRealizacao = result;
              Swal.close()
            },
            error => {
              this.showError(error)
            }
          )
        }
        if (this.historico.CidSubCategoriaRealizacao) {
          this.historico.CidSubCategoriaRealizacao.texto = this.historico.CidSubCategoriaRealizacao.codigo + ' - ' + this.historico.CidSubCategoriaRealizacao.nome
        }
        Swal.close()
      },
      error => {
        this.showError(error)
      }
    )
  }

  obterRegulacaoConsulta = (id) => {
    this.service.Get(`RegulacaoConsulta/${id}`).then(
      result => {        
        this.historico = result;

        this.consulta = result;
        if (this.consulta.estabelecimento_id_executor == null)
          this.consulta.estabelecimento_id_executor = 0;
        this.cidadao = this.consulta.Cidadao;
        if (this.consulta.AgendaHora != null)
          this.agendaHoraTroca = this.consulta.AgendaHora;

        for (let log of this.historico.Logs) {
          for (let usuario of this.listaUsuarios) {
            if (log.usuario_id == usuario.id) {
              log.usuario_nome = usuario.nome
            }
          }
        }
        if (!this.historico.cid_subcategoria_id) {
          // this.historico.cid_subcategoria_texto = 'NÃO INFORMADO'
          if (this.historico.AgendaHora) {
            
            this.getAgendaDia(this.historico.AgendaHora.agenda_dia_id).then(
              result => {
                var data = result['agenda_em']
                this.historico.AgendaHora.agendamento = data.split('T')[0] + 'T' + this.historico.AgendaHora.hora
                if (this.historico.estabelecimento_id_executor) {
                  this.getEstabelecimentos(this.historico.estabelecimento_id_executor).then(
                    result => {
                      this.historico.estabelecimento_executor_nome = result['nome'];
                      Swal.close()
                      return
                    },
                    error => {
                      this.showError(error)
                    }
                  )
                }
                else {
                  if (this.historico.AgendaHora) {
                    this.service.Get(`AgendaDia/${this.historico.AgendaHora.agenda_dia_id}`).then(
                      result => {
                        var agenda: any = {}
                        agenda = result;
                        this.service.Get(`Estabelecimento/${agenda.estabelecimento_id}`).then(
                          result => {
                            var estabelecimento: any = result;
                            this.historico.estabelecimento_executor_id = estabelecimento.id
                            this.historico.estabelecimento_executor_nome = estabelecimento.nome
                            Swal.close()
                            return
                          },
                          error => {
                            this.showError(error)
                          }
                        )
                      },
                      error => {
                        this.showError(error)
                      }
                    )
                  }
                }
              },
              error => {
                this.showError(error)
              }
            )
          }
          else {
            //this.historico.AgendaHora.agendamento = 'NÃO INFORMADO'
            Swal.close()
            return
          }
        }
        if (this.historico.cid_subcategoria_id) {
          this.getCid(this.historico.cid_subcategoria_id).then(
            result => {
              this.historico.cid_subcategoria_texto = result['codigo'] + ' ' + result['nome']
              if (this.historico.AgendaHora) {
                this.getAgendaDia(this.historico.AgendaHora.agenda_dia_id).then(
                  result => {
                    var data = result['agenda_em']                    
                    
                    this.historico.AgendaHora.agendamento = data === undefined? null: data.split('T')[0] + 'T' + this.historico.AgendaHora.hora
                    if (this.historico.estabelecimento_id_executor) {
                      this.getEstabelecimentos(this.historico.estabelecimento_id_executor).then(
                        result => {
                          this.historico.estabelecimento_executor_nome = result['nome'];
                          Swal.close()
                          return
                        },
                        error => {
                          this.showError(error)
                        }
                      )
                    }
                    else {
                      if (this.historico.AgendaHora) {
                        this.service.Get(`AgendaDia/${this.historico.AgendaHora.agenda_dia_id}`).then(
                          result => {
                            var agenda: any = {}
                            agenda = result;
                            this.service.Get(`Estabelecimento/${agenda.estabelecimento_id}`).then(
                              result => {
                                var estabelecimento: any = result;                                
                                this.historico.estabelecimento_executor_id = estabelecimento === null ? null : estabelecimento.id
                                this.historico.estabelecimento_executor_nome = estabelecimento === null ? null : estabelecimento.nome
                                Swal.close()
                                return
                              },
                              error => {
                                this.showError(error)
                              }
                            )
                          },
                          error => {
                            this.showError(error)
                          }
                        )
                      }
                    }
                  },
                  error => {
                    this.showError(error)
                  }
                )
              }
              else {
                //this.historico.AgendaHora.agendamento = 'NÃO INFORMADO'
                Swal.close()
                return
              }
            }
          )
        }
        // if (this.historico.status == 'AGENDADO'){

        // }
        // if (this.historico.status == 'CANCELADO'){

        // }
        // if (this.historico.status == 'REALIZADO'){

        // }
        if (this.historico.cid_subcategoria_id_realizacao) {
          this.getCid(this.historico.cid_subcategoria_id_realizacao).then(
            result => {
              this.historico.cid_subcategoria_texto_realizacao = result['codigo'] + ' ' + result['nome']
            }
          )
        }
      },
      error => {
        this.showError(error)
      }
    )
  }

  showError = (error) => {
    if (typeof error == 'string') {
      Swal.fire('Erro', `${error}`, 'error');
      return
    }
    if (error.status == 401 || error.error.status == 401) {
      Swal.close()
      this.authService.logoutUser()
    }
    if (error.status === 404) {
      Swal.fire('Atenção', `${error.error}`, 'warning');
      return
    }
    if (error.status) {
      Swal.fire({ icon: 'error', title: 'Erro', html: `${error.status} - ${error.error.erros[0].messagem}` })
      return
    }
    if (error.alert) {
      Swal.fire('Atenção', `${error.txt}`, 'warning');
      return
    }
  }

  getEstabelecimentos = (id) => {
    
    return new Promise((resolve, reject) => {
      this.service.Get(`Estabelecimento/${id}`).then(
        result => {
          resolve(result)
        },
        error => {
          reject(error)
        }
      )
    })
  }

  getCid = (id) => {
    return new Promise((resolve, reject) => {
      this.service.Get(`CidSubCategoria/${id}`).then(
        result => {
          resolve(result)
        },
        error => {
          reject(error)
        }
      )
    })
  }

  getProfissional = () => {
    return new Promise((resolve, reject) => {
      this.service.Get(`Usuario`).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error)
        }
      )
    })
  }

  getAgendaDia = (id) => {
    return new Promise((resolve, reject) => {
      this.service.Get(`AgendaDia/${id}`).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error)
        }
      )
    })
  }

  obterDadosImpressoHistorico = () => {
    Swal.fire('Favor aguarde')
    Swal.showLoading()
    this.service
        .PostImpresso(`Documento/impresso-pdf/${this.nomeImpressoHistorico}`, [
          {
            nome: "id",
            valor: this.regulacaoId.toString(),
          },
        ])
        .then((res) => {
          if (res) {
            var link: any = res;
        Swal.close();
            window.open(link, "_blank");
          }
        })
        .catch((err) => {
          Swal.close();
          Swal.fire("Erro", "Erro ao gerar impresso", "error");
        });
  }
  

  imprimirSolicitacaoExame = (historico) => {
    this.solicitacaoExame = {}
    this.solicitacaoExame = historico
  }

  limparImpressos = () => {
    this.regulacaoId = ''
    this.solicitacaoExame = {}
    setTimeout(() => {
      Swal.close();
    }, 500)
  }

  alterarDataAgendamento = () => {
    var data = new Date();
    var dataAtual: any = (data.getDate().toString().length == 1 ? '0' + data.getDate().toString() : data.getDate().toString()) + ((data.getMonth() + 1).toString().length == 1 ? '0' + (data.getMonth() + 1).toString() : (data.getMonth() + 1).toString()) + data.getFullYear();
    this.filtroAgendamento = {}
    this.filtroAgendamento.estabelecimento_id = 0;
    this.filtroAgendamento.ocupacao_id = 0;
    this.filtroAgendamento.profissional_id = 0;
    this.filtroAgendamento.data_agenda_inicio = dataAtual;
    this.filtroAgendamento.data_agenda_fim = dataAtual;
    this.filtroAgendamento.visualisandoHorarios = false;
    this.filtroAgendamento.exibirAgenda = false;
    this.filtroAgendamento.agendas = [];
    this.alterandoAgenda = true;
  }

  goBack = () => {
    this.alterandoAgenda = false;
  }

  resultPostAgendamento = () => {
    if (this.tipoRegulacaoHistorico == 1)
      this.obterRegulacaoConsulta(this.consulta.id);
    if (this.tipoRegulacaoHistorico == 2)
      this.obterRegulacaoExame(this.consulta.id);
    this.alterandoAgenda = false;
  }

}
